"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalSeparator = exports.HorizontalSeparator = exports.SeparatorSize = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
var SeparatorSize;
(function (SeparatorSize) {
    SeparatorSize["None"] = "none";
    SeparatorSize["Small"] = "small";
    SeparatorSize["Medium"] = "medium";
    SeparatorSize["Large"] = "large";
})(SeparatorSize || (exports.SeparatorSize = SeparatorSize = {}));
const HorizontalSeparator = ({ size = SeparatorSize.Large, }) => (0, jsx_runtime_1.jsx)("hr", { className: (0, classnames_1.default)(styles_module_css_1.default.separator, styles_module_css_1.default[size]) });
exports.HorizontalSeparator = HorizontalSeparator;
const VerticalSeparator = ({ size = SeparatorSize.Large, }) => (0, jsx_runtime_1.jsx)("div", { role: "separator", className: (0, classnames_1.default)(styles_module_css_1.default.separatorV, styles_module_css_1.default[size]) });
exports.VerticalSeparator = VerticalSeparator;
